import {ArticleButton, ProductCardField} from "../types/product-card-header.types";

export const productCardFields: Array<ProductCardField> = [
  {
    label: 'Артикул продукта',
    key: 'article'
  },
  {
    label: 'Название продукта',
    key: 'title'
  }
];

export const articleButtons: Array<ArticleButton> = [
  {
    key: 'wildberries',
    label: 'Артикул WB'
  },
  {
    key: 'ozon',
    label: 'Артикул OZON'
  }
]
